/**
 * @fileoverview Logic to bypass Shadow DOM and apply custom wave button styles.
 * This script reads a master CSS block and injects it into the Shopify form's Shadow Root.
 */

// Define the core function to apply styles and class
function applyDynamicCacaoButtonStyles(hostId) {
    // 1. Get the content of the master CSS block by its ID
    const styleElement = document.getElementById('cacao-button-master-styles');
    if (!styleElement) {
        // Master CSS block not yet loaded or ID is incorrect
        // The retry function will handle retrying.
        return false; 
    }
    const dynamicCSS = styleElement.textContent;

    // 2. Get the host element for the Shadow DOM
    const embedHost = document.getElementById(hostId);

    // Check if the host is available and has rendered its Shadow Root
    if (embedHost && embedHost.shadowRoot) {
        const shadowRoot = embedHost.shadowRoot;

        // 3. Find the submit button inside the Shadow Root using its unique class
        // This is the target element for the style and class injection
        const submitButton = shadowRoot.querySelector('button[type="submit"]');

        if (submitButton) {
            // 4. Inject the READ CSS block into the Shadow Root
            const style = document.createElement('style');
            style.textContent = dynamicCSS;
            // Appending the style element is what bypasses the Shadow DOM style barrier
            shadowRoot.appendChild(style);

            // 5. Apply the specific class used in the injected CSS to the button
            // This activates all the complex wave and ::before styles
            var classList = submitButton.classList;
            while (classList.length > 0) {
            classList.remove(classList.item(0));
            }
            classList.add('cacao-button');
            classList.add('cacao-button-primary');

            console.log("Wave button styles successfully injected into Shopify form.");
            return true; // Success
        }
    }
    return false; // Not yet ready (element or Shadow Root missing)
}

// Function to implement a retry mechanism for dynamic apps
function retryApplyStyles(hostId) {
    // If applyDynamicCacaoButtonStyles returns false, retry after a delay.
    if (!applyDynamicCacaoButtonStyles(hostId)) {
        // Retry every 500ms until successful.
        setTimeout(()=>retryApplyStyles(hostId), 500); 
    }
}

// Start the process when the entire page content is loaded
// This ensures the custom style tag is available before the script runs.
window.addEventListener('load', () => {
    // Use a small initial delay to give dynamic Shopify components time to render the Shadow DOM
    // setTimeout(()=>retryApplyStyles('app-embed-container-586900'), 200); 
});
